export default __webpack_public_path__ + "static/summer_containers49-08f7fca49f0a0a2561c20035eefb58ca.webp";